import { Icon, Typography } from "@/components/atoms";

export const DriverAppCallout = () => (
  <div className="flex w-full gap-3 rounded-lg border border-info bg-info-light px-5 py-4 shadow-[0_0_0_4px_rgba(46,144,250,0.3)]">
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded bg-warning">
      <Icon name="LampCharge" size="lg" className="text-white" />
    </div>
    <div className="flex flex-col gap-1">
      <Typography variant="title" className="text-neutral-black">
        Steps 3&ndash;6 happen in the Driver App on your phone
      </Typography>
      <Typography variant="paragraph" className="text-neutral-black">
        Each one ticks off here automatically once you&apos;ve done it &mdash; you don&apos;t need to come back and mark anything complete.
      </Typography>
    </div>
  </div>
);
